import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import styled from "@emotion/styled";
import { AppLogo } from "@ui/components/common/app-logo";
import { RoutesPath } from "@ui/navigation/routes";
import {
	ProfessionalInformationValidationSteps,
	progressionStepsData,
} from "@ui/pages/validate-professional-information/components/register-progression-bar";
import { RegisterProgressionStep as Step } from "@ui/pages/validate-professional-information/components/register-progression-step";
import { colors } from "@ui/style/colors";
import { isNotNil } from "@utils/assert";
import React from "react";
import { ContactSupport } from "@ui/components/buttons/contact-support";

interface LongRegisterProgressionBarProps {
	step?: ProfessionalInformationValidationSteps;
}

export const LongRegisterProgressionBar = ({ step: currentStep }: LongRegisterProgressionBarProps): JSX.Element => {
	const { format } = useI18n();
	const navigate = useNavigate();

	const navigateToLogin = async () => {
		navigate(RoutesPath.Login);
	};

	return (
		<>
			<Container>
				<StyledAppLogo height={32} width={125} onClick={() => navigateToLogin()} />
				{isNotNil(currentStep) && (
					<StepsContainer>
						{progressionStepsData.map((step, stepIndex) => (
							<Step
								key={step.step}
								addSeparator={stepIndex > 0}
								active={step.step <= currentStep}
								label={format(step.label)}
							/>
						))}
					</StepsContainer>
				)}
			</Container>
			<SubnavigationContainer>
				<ContactSupport uiStyle="secondary" />
			</SubnavigationContainer>
		</>
	);
};

const SubnavigationContainer = styled.div`
	position: absolute;
	top: 0px;
	right: 0px;
	margin-top: 110px;
	margin-right: 65px;
`;

const StyledAppLogo = styled(AppLogo)`
	cursor: pointer;
`;

const StepsContainer = styled.div`
	display: flex;
	gap: 4px;
	place-items: center;
	place-content: center;
	width: 100%;
	padding-left: 5rem;
`;

const Container = styled.div`
	height: 80px;
	border-bottom: 1px solid ${colors.primary25};
	background-color: ${colors.white};
	display: grid;
	grid-template-columns: 128px 1fr 128px;
	place-items: center;
	padding-left: 40px;
	padding-right: 40px;
`;
